// @ts-nocheck
import { del, get, post } from "@insite/client-framework/Services/ApiService";
import { GetGiftCardsInfoModel } from "@store/Framework/Types/ApiModels";

const giftCardsUrl = `/api/v1/custom/carts/current/giftcards`;

export const getGiftCardsInfos = async () => {
    const data: GetGiftCardsInfoModel = await get(giftCardsUrl);
    return data;
};

export const addGiftCardToCart = async (giftCardId: string) => {
    try {
        await post(`${giftCardsUrl}/${giftCardId}`);
        return {
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: error.errorMessage,
        };
    }
};

export const unassignGiftCard = async (giftCardId: string) => {
    try {
        await del(`${giftCardsUrl}/${giftCardId}`);
        return {
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: error.errorMessage,
        };
    }
};

export const unassignAllGiftCards = async () => {
    try {
        await del(`${giftCardsUrl}`);
        return {
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: error.errorMessage,
        };
    }
};
